import React from "react"
import styled from "@emotion/styled"
import Section from "src/components/Section"
import Button from "src/components/Button"
import Grid from "src/components/Grid"
import ThemeSelector from "src/components/ThemeSelector"
import { mq, util, globals } from "src/styles"
import { getSlugLink } from "src/utils/format"

const Wrapper = styled(Section)`
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
    `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const StyledBar = styled(ThemeSelector)`
  ${util.responsiveStyles("padding", 40, 30, 28, 24)}
  text-align: center;
  h4 {
    margin: -0.25em 0 0.75em 0;
    ${mq.largeAndUp} {
      margin: 0 1em 0 0;
    }
  }
  .button {
    flex-shrink: 0;
  }
  ${mq.mediumAndUp} {
    border-radius: var(--card-border-radius);
  }
  ${mq.largeAndUp} {
    border-radius: var(--card-border-radius);
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const CtaBarElement = ({ headingSize, headline, button, theme }) => {
  if (!button) {
    return false
  }
  const actionType = button?.type || "pageLink"
  return (
    <StyledBar setTheme={theme}>
      <h4 className={headingSize ? headingSize : "h3"}>{headline}</h4>
      <Button
        setTheme="white"
        to={
          actionType === "externalLink"
            ? button?.externalLink
            : getSlugLink(button?.link, false, button?.linkSection)
        }
        external={actionType === "externalLink"}
        target={button?.newTab ? "_blank" : ""}
        title={button?.title}
        name={button?.title}
      >
        {button?.title}
      </Button>
    </StyledBar>
  )
}

const CtaBar = ({
  className,
  nextTheme,
  prevTheme,
  theme,
  spacing,
  isFirstSection,
  headingSize,
  headline,
  button,
  id,
  hideMobile,
  hideDesktop,
}) => {
  return (
    <Wrapper
      className={className}
      prevTheme={prevTheme}
      nextTheme={nextTheme}
      isFirstSection={isFirstSection}
      id={id}
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      <Grid small="[1]" medium="1 [12] 1">
        <CtaBarElement
          headingSize={headingSize ? headingSize : "h3"}
          headline={headline}
          button={button}
          theme={theme}
        />
      </Grid>
    </Wrapper>
  )
}

export default CtaBar
